import config from "../config";
import { ResponseDto } from "../dtos/common/responseDto";
import type {
  PDA1091_R01AdjustRequest,
  PDA1091_R01AdjustResultDto,
  PDA1091_R01ScanResultDto,
} from "../containers/PDA/PDA1091_R01/PDA1091_R01Dto";
import { getData, putData } from "../utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/PDA1091_R01`;

/** itemCd 스캔 → 지정 창고 시스템 총재고 */
export const scanItemR02 = async (warehouseCd: string, scanValue: string) => {
  const url = `${baseUrl}/scan/${encodeURIComponent(warehouseCd)}/${encodeURIComponent(scanValue)}`;
  return await getData<ResponseDto<PDA1091_R01ScanResultDto>>(url);
};

/** 실사 등록(일괄) */
export const adjustStockR02 = async (request: PDA1091_R01AdjustRequest) => {
  return await putData<PDA1091_R01AdjustRequest, ResponseDto<PDA1091_R01AdjustResultDto>>(
    baseUrl,
    request
  );
};